export function justNumbers(value) {
    if (value) {
        const onlyNumber = /[^0-9]/g
        return value.toString().replace(onlyNumber, '')
    }
    return ''
}
